import React from "react";
import Table from "react-bootstrap/Table";
import { ResultWithRider, SnapshotWithEventandRider } from "../../../../types/model";
import getCountryISO2 from "country-iso-3-to-2";
import ReactCountryFlag from "react-country-flag";
import { calculatePickAndRankPoints } from "../../../../utils/utils";


interface PointsBreakdownPickandRankProps {
	results: ResultWithRider[];
	snapshot: SnapshotWithEventandRider;
	numberMen: number;
	numberWomen: number;
}

const PointsBreakdownPickandRank: React.FC<PointsBreakdownPickandRankProps> = ({
	results,
	snapshot,
	numberMen,
	numberWomen,
}) => {
	return (
		<Table striped bordered hover style={{ fontSize: "0.7rem" }}>
			<thead>
				<tr>
					<th>Rider</th>
					<th>Score</th>
					<th>Chosen Rank</th>
					<th>Actual Rank</th>
					<th>Points</th>
				</tr>
			</thead>
			<tbody>
				{results?.length > 0 &&
					results
						.filter(
							(result) =>
								result.event === snapshot.event._id &&
								snapshot.riders.some(
									(rider) => rider.rider?._id === result.rider?._id
								)
						)
						.map((filteredResult: ResultWithRider) => (
							<tr key={filteredResult._id}>
								<td>
									{getCountryISO2(
										(filteredResult?.rider?.country ?? "").toUpperCase().trim()
									) ? (
										<ReactCountryFlag
											countryCode={getCountryISO2(
												(filteredResult.rider.country ?? "")
													.toUpperCase()
													.trim()
											)}
											svg
											style={{ width: "3.5rem" }}
										/>
									) : (
										filteredResult.rider?.country
									)}
									<b>{filteredResult.rider?.last_name}</b>{" "}
									{filteredResult.rider?.first_name}
								</td>
								<td>{filteredResult?.finals_data?.score}</td>
								<td>
									{
										snapshot.riders.find(
											(rider) =>
												rider.rider?._id === filteredResult.rider?._id
										)?.rank ?? "N/A"
									}
								</td>
								<td>{filteredResult?.finals_data?.rank}</td>
								<td>
									{calculatePickAndRankPoints(
										filteredResult.finals_data?.rank ?? 0,
										snapshot.riders.find(
											(rider) =>
												rider.rider?._id === filteredResult.rider?._id
										)?.rank ?? "N/A",
										filteredResult.rider?.gender,
										numberMen,
										numberWomen
									)}
								</td>
							</tr>
						))}
			</tbody>
		</Table>
	);
};

export default PointsBreakdownPickandRank;